import {
  DEALER_LISTING_REQUEST,
  DEALER_LISTING_FAIL,
  DEALER_LISTING_SUCCESS,
  DEALER_LISTING_UPDATE_USER_STATUS,
  DEALER_PHONE,
  VERIFIED_DEALER_EMAIL
} from "../../constants/actions";

const initialState = {
  loading: false,
  loginSucces: false,
  dealerListing: [],
  totalDealers: 0,
  error: false,
};

const dealerListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEALER_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DEALER_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        loginSucces: true,
        totalDealers: action.payload.total,
        dealerListing: action.payload.result,
      };
    case DEALER_LISTING_UPDATE_USER_STATUS:
      return {
        ...state,
        dealerListing: state.dealerListing.map((dealer) =>
          dealer.id === action.payload.userId
            ? { ...dealer, status: action.payload.status }
            : dealer
        ),
      };
    case VERIFIED_DEALER_EMAIL:
      return {
        ...state,
        dealerListing: state.dealerListing.map((dealer) =>
          dealer.id === action.payload.userId
            ? { ...dealer, email_verified: action.payload.email_verified }
            : dealer
        ),
      };
    case DEALER_PHONE:
      return {
        ...state,
        dealerListing: state.dealerListing.map((dealer) =>
          dealer.id === action.payload.userId
            ? { ...dealer, otp_verified: action.payload.otp_verified }
            : dealer
        ),
      };
    case DEALER_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default dealerListingReducer;
